/**
 * 页脚。备案号和工信部链接是**法定必须**展示的内容 —— 备案通过后网站首页
 * 必须标明 ICP 备案号并链接到 beian.miit.gov.cn，否则专项核查可撤销备案。
 * 改这个组件前先确认这一点还成立。
 */
import { site, hasIcp, hasMps, mpsUrl, MIIT_URL, legalNotice } from "../data/site";
import { legalPages } from "../data/legal";
import { routeToPath, onNavClick } from "../router";

type Props = { onNavigate: (route: string) => void };

export function ComplianceFooter({ onNavigate }: Props) {
  return (
    <footer className="compliance-footer">
      <div>
        <strong>{site.name}</strong>
        <span>{site.company}</span>
        <span>{site.email}</span>
        {legalPages.map((page) => (
          <a
            key={page.key}
            href={routeToPath(page.key)}
            onClick={(e) => onNavClick(e, page.key, onNavigate)}
          >
            {page.title}
          </a>
        ))}
      </div>
      <div>
        {hasIcp ? (
          <a href={MIIT_URL} target="_blank" rel="noreferrer noopener">
            {site.icp}
          </a>
        ) : (
          <span>{site.icp}</span>
        )}
        {hasMps ? (
          <a className="mps-link" href={mpsUrl()} target="_blank" rel="noreferrer noopener">
            <img className="mps-badge" src="/gongan-badge.png" alt="" width={15} height={16} />
            {site.mps}
          </a>
        ) : (
          <span>{site.mps}</span>
        )}
        <span>{legalNotice}</span>
      </div>
    </footer>
  );
}
